import React from "react";
import PropTypes from "prop-types";
import Fade from "react-reveal/Fade";

import styles from "./Text.module.scss";

const gradientStyle = (fromColor, toColor) => ({
  background: `linear-gradient(to right, ${fromColor} 0%, ${toColor} 100%)`,
  WebkitBackgroundClip: "text"
});

const Text = ({ category, title, paragraph, gradientColor }) => (
  <Fade left cascade duration={1000} distance="10%">
    <div className={styles.textBlock}>
      {!!category && (
        <div>
          <h2
            style={gradientStyle(
              gradientColor.fromColor,
              gradientColor.toColor
            )}
          >
            {category}
          </h2>
        </div>
      )}
      {(!!title || !!paragraph) && (
        <div className={styles.blockContent}>
          {!!title && <h1>{title}</h1>}
          {!!paragraph && <p>{paragraph}</p>}
        </div>
      )}
    </div>
  </Fade>
);

Text.propTypes = {
  category: PropTypes.string,
  title: PropTypes.string,
  paragraph: PropTypes.string
};

export default Text;
